import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { CtaBand } from '../components/ui/CtaBand';
import { FaqList } from '../components/ui/FaqList';
import { SectionHeading } from '../components/ui/SectionHeading';
import { faqs, steps } from '../data/site';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
export function HowItWorks() {
  const {
    brand,
    text
  } = useBrand();
  useDocumentMeta({
    title: `How care works — ${brand.name}`,
    description: 'Intake, labs, a written protocol you approve, then ongoing adjustment against real data. A clinic that shows its work.'
  });
  return <main data-id="element-376" data-mp="1taovkz3jia7i">
      <PageHeader eyebrow="How it works" title="A clinic that shows its work." intro="Republic runs the same sequence for every patient: intake, labs, a written protocol you approve, then ongoing adjustment against real data." data-id="element-377" data-mp="1tb8cqdld8ukh" />

      <section className="bg-cream" data-id="element-378" data-mp="10sb4dicplmhe">
        <div className="mx-auto max-w-shell px-6 pb-20 pt-12 md:px-8 md:pb-28" data-id="element-379" data-mp="1rs6hkhz6zvx1">
          <ol data-id="element-380" data-mp="1nq1nxj8quzae">
            {steps.map((step, index) => <li key={step.label} className="rule grid gap-6 py-10 lg:grid-cols-[6rem_1fr_1fr] lg:gap-12" data-id="element-381" data-mp="1nql7f4e1lvqj" data-mpi={index}>
                <div data-id="element-382" data-mp="1ixie8xd6goav">
                  <span className="font-serif text-4xl text-brick" data-id="element-383" data-mp="1ix0alfo6r7sx">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <p className="mt-2 text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-384" data-mp="191yicaym5pm4">
                    {step.duration}
                  </p>
                </div>
                <h2 className="font-serif text-3xl leading-tight text-ink md:text-[2.5rem]" data-id="element-385" data-mp="zzz0xhjosjin">
                  {step.title}
                </h2>
                <p className="max-w-xl text-base leading-relaxed text-ink-soft md:text-lg" data-id="element-386" data-mp="v38m0xjmbtyt">
                  {text(step.detail)}
                </p>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="border-y border-ink/10 bg-cream-deep text-ink" data-id="element-387" data-mp="2pdkjb1znriwj">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-388" data-mp="38iqvd06b8sel">
          <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-389" data-mp="3dbjyjjm4rsok">
            <img src={brand.images.clinician} alt={`A ${brand.name} clinician reviewing a patient panel`} className="aspect-[3/2] w-full rounded-brand object-cover" data-id="element-390" data-mp="2zk52oc74jx03" />
            <div data-id="element-391" data-mp="3s9cda9jusd1p">
              <SectionHeading eyebrow="Your care team" tone="cream" title="One clinician, not a queue." intro="You are assigned a clinician licensed in your state who stays with you across renewals. Messages are answered within one business day, and dose changes do not require a new visit fee." data-id="element-392" data-mp="3s8ssml2tjajz" />
              <dl className="rule-light mt-10 grid gap-8 pt-8 sm:grid-cols-3" data-id="element-393" data-mp="26tn5frt30pul">
                {[{
                value: '< 24 hrs',
                label: 'Median protocol turnaround'
              }, {
                value: '2,100',
                label: 'Partner draw sites'
              }, {
                value: '50',
                label: 'States licensed'
              }].map(stat => <div key={stat.label} data-id="element-394" data-mp="1zdi3r5x9250y">
                    <dt className="font-serif text-3xl text-brick" data-id="element-395" data-mp="2db6qykesho96">{stat.value}</dt>
                    <dd className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-396" data-mp="28c3liyuwdg0o">{stat.label}</dd>
                  </div>)}
              </dl>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-cream-light" data-id="element-397" data-mp="1glgz1mxsnkjm">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-398" data-mp="1gikzju6asnt2">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-399" data-mp="1ucubyi175k5o">
            <SectionHeading eyebrow="Questions" title="Answered plainly." data-id="element-400" data-mp="1pl3xbzv88a8g" />
            <FaqList items={faqs} data-id="element-401" data-mp="11vi3lrxmin7u" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-402" data-mp="11tf3ug6o5fpx" />
    </main>;
}